import { useState, type FC, type FormEvent } from 'react';
import { useCustomMutation } from '@refinedev/core';
import ProspectEnrichmentPanel from './ProspectEnrichmentPanel';
import ProspectDataDisplay from './ProspectDataDisplay';

interface ProfileResult {
  detectedPersona?: string;
  painPoints?: string[];
  relevantFeatures?: string[];
  approachMessage?: string;
  toneRecommendation?: string;
  confidenceScore?: number;
  rawContent?: string;
}

interface ProspectProfilerProps {
  onGenerated: () => void;
}

const ProspectProfiler: FC<ProspectProfilerProps> = ({ onGenerated }) => {
  const [profileText, setProfileText] = useState('');
  const [knownPersona, setKnownPersona] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [sector, setSector] = useState('');
  const [result, setResult] = useState<ProfileResult | null>(null);

  const { mutate, isLoading } = useCustomMutation();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (profileText.trim().length < 20 || isLoading) return;
    mutate(
      {
        url: '/api/v1/admin/growth/sales/profile-prospect',
        method: 'post',
        values: {
          profileText: profileText.trim(),
          knownPersona: knownPersona || undefined,
          companyName: companyName.trim() || undefined,
          sector: sector.trim() || undefined,
        },
      },
      {
        onSuccess: (response) => {
          const d = response?.data?.data ?? response?.data ?? {};
          setResult(d as ProfileResult);
          onGenerated();
        },
      },
    );
  };

  return (
    <div className="space-y-5">
      <ProspectEnrichmentPanel
        profileText={profileText}
        knownPersona={knownPersona}
        companyName={companyName}
        sector={sector}
        isLoading={isLoading}
        onProfileTextChange={setProfileText}
        onKnownPersonaChange={setKnownPersona}
        onCompanyNameChange={setCompanyName}
        onSectorChange={setSector}
        onSubmit={handleSubmit}
      />
      {result && <ProspectDataDisplay result={result} />}
    </div>
  );
};

export default ProspectProfiler;
